/*  MUI  */
import { Button, CircularProgress, Grid, Paper } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';
import { AdminBackButton } from 'application/Shared/Components/Buttons/BackButton';
import { MultiInput } from 'application/Shared/Components/Inputs';
import { Helpers, Notify } from 'application/Shared/Helpers';
import { Confirm } from 'application/Shared/Modals/Confirm';
import { Requests } from 'application/Shared/Requests';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'router/withRouter';

class Domains extends Component {
    constructor(props) {
        super(props);
        this.state = {
            domains: [],
            domainsMap: [],
            loaded: false,
            partner: false,
            promptConfirm: false
        };

        /* requests */
        this.requests = new Requests();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const { props } = this;
        const { match } = props;
        const { clientId } = match.params;

        /* params */
        const params = { size: 1 };
        if (clientId) {
            params.id = clientId;
            params.includeClients = true;
        }

        try {
            const response = await axios.get('/tenant', {
                cancelToken: this.requests.token(),
                params
            });
            if (!Helpers.isset(response, 'data', 'data', 0, 'domains')) {
                return;
            }
            const tenant = response.data.data[0];
            const { domains } = tenant;

            let partner = false;
            if (Helpers.isset(props, 'session', 'tenant', 'partner')) {
                partner = props.session.tenant.partner;
            }

            const domainsMap = [];

            domains.forEach((domain) => {
                domainsMap.push({
                    domain
                });
            });

            this.setState({
                domains,
                domainsMap,
                loaded: true,
                partner,
                tenant
            });
        } catch (e) {
            /* */
        }
    };

    unload = () => {
        this.requests.cancel();
    };

    save = async () => {
        const { t, match } = this.props;
        const { clientId } = match.params;
        const { tenant, domains } = this.state;
        const { id } = tenant;

        this.setState({ promptConfirm: false });

        /* params */
        const params = {
            domains,
            setReprocessLogs: true
        };
        if (clientId) {
            params.partnerUpdate = true;
        }

        try {
            await axios.put(`/tenant/${id}`, params);
        } catch (e) {
            debug.e('PUT Error', e);
            Notify.e(t('Domains.save_fail'));
            return;
        }

        Notify.s(t('Domains.save_success'));
    };

    updateDomains = ({ domainsMap }) => {
        let domains = domainsMap.map((d) => {
            const { domain } = d;
            if (domain) {
                return domain;
            }
            return null;
        });

        domains = domains.filter((el) => el != null);

        this.setState({ domains });
    };

    render() {
        const { t } = this.props;
        const { loaded, domainsMap, promptConfirm, partner } = this.state;

        return (
            <>
                <PageTitle title={t('Common.domain_configuration')} />
                <AdminBackButton linkTo="/configure" />

                <Paper elevation={0} variant="outlined">
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            {t('Domains.description')}
                            <hr />
                        </Grid>
                        {!loaded && (
                            <Grid
                                item
                                xs={12}
                                display="flex"
                                justifyContent="center"
                                marginBottom="32px"
                            >
                                <CircularProgress />
                            </Grid>
                        )}
                        {loaded && (
                            <>
                                <Grid item xs={12}>
                                    <MultiInput
                                        fields={[
                                            { field: 'domain', label: 'Domain' }
                                        ]}
                                        max={10}
                                        min={0}
                                        onChange={(p) =>
                                            this.updateDomains({
                                                domainsMap: p.rows
                                            })
                                        }
                                        values={domainsMap}
                                        zeroText="Add Company Domains"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <hr />
                                    <Button
                                        style={{ float: 'right' }}
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                            this.setState({
                                                promptConfirm: true
                                            })
                                        }
                                        disabled={!partner}
                                    >
                                        {t('Common.save')}
                                    </Button>
                                </Grid>
                            </>
                        )}
                        {promptConfirm && (
                            <Confirm
                                modalOpen={!!promptConfirm}
                                promptConfirmFn={() => this.save()}
                                promptCancelFn={() =>
                                    this.setState({ promptConfirm: false })
                                }
                                promptTitle={t('Domains.confirm_title')}
                                promptText={t('Domains.confirm_description')}
                            />
                        )}
                    </Grid>
                </Paper>
            </>
        );
    }
}
export default withRouter(withTranslation()(Domains));
